import { useFetch, usePost } from '@selfserve/react-hooks';
import { apiEndpoints } from '@selfserve/react-utils';
import { WebinarWizardData, WebinarWizardAiOption } from './interfaces';

export const useSetWebinarData = (id: string) => {
  const url = apiEndpoints.setWebinarData.replace(':id', id);
  return usePost<WebinarWizardData, any>(url);
};

export const useGetWebinarOptionsByAi = (text: string, isClicked: boolean) => {
  const url = apiEndpoints.getWebinarOptionsByAi.replace(':text', text);
  return useFetch<WebinarWizardAiOption>(url, undefined, {enabled: !!(url && text && isClicked)});
};

export * from './interfaces';
export * from './schemas';
